import { useCallback } from "react";
import { useRouter } from "next/router";
import { baseApi } from "@/api/baseApi";
import { uniqueId } from "lodash";

type AnalyticsParams = Record<string, any>;

export enum AnalyticsEvents {
  REGISTRATION_CLICKED = "registration_clicked",
  REGISTRATION_OTP_SENT = "registration_otp_sent",
  REGISTRATION_SUCCESS = "registration_success",
  TUTORIAL_STARTED = "tutorial_started",
  TUTORIAL_STRATEGY_SELECTED = "tutorial_strategy_selected",
  TUTORIAL_BACKTEST_LANDED = "tutorial_backtest_landed",
  TUTORIAL_FINISHED = "tutorial_finished",
  PAGE_VIEW = "page_view",
}

interface TrackEventProps {
  event_name: AnalyticsEvents;
  params?: AnalyticsParams;
  client_id?: string;
  user_id?: string;
  page_path?: string;
}

export function useAnalytics(autoTrackPageViews = true) {
  const router = useRouter();

  const getClientId = useCallback(() => {
    let cid = localStorage.getItem("client_id");
    if (!cid) {
      cid = uniqueId();
      localStorage.setItem("client_id", cid);
    }
    return cid;
  }, []);

  const trackEvent = useCallback(
    async (event: TrackEventProps) => {
      const payload = {
        ...event,
        client_id: event.client_id || getClientId(),
        page_path: event.page_path || window.location.href,
      };

      try {
        await baseApi.post("/api/external_analysis", payload);
      } catch (error) {
        console.error("Analytics API error:", error);
      }
    },
    [getClientId]
  );

  return { trackEvent };
}
